import type { ReactNode } from 'react';
import { Images } from '../../utils/imageConstants';
import './ComingSoon.scss';

export interface ComingSoonProps {
  /** Logo image source. Defaults to Cric Center main logo */
  logoSrc?: string;
  /** Main headline text */
  headline: string;
  /** Description text. Can be string or ReactNode for multi-line content */
  description: string | ReactNode;
}

const ComingSoon = ({
  logoSrc = Images.main_logo,
  headline,
  description,
}: ComingSoonProps) => {
  return (
    <div className="coming-soon">
      <div className="coming-soon__panel">
        <div className="coming-soon__logo">
          <img src={logoSrc} alt="Logo" className="coming-soon__logo-image" />
        </div>
        <h1 className="coming-soon__headline">{headline}</h1>
        <div className="coming-soon__description">
          {typeof description === 'string' ? (
            <>
              {description
                .split('\n')
                .filter((line) => line.trim())
                .map((line, i) => (
                  <p key={i}>{line.trim()}</p>
                ))}
            </>
          ) : (
            description
          )}
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
